import store from "@/redux/store/localStorageStore";
import { setParam, clearParams } from "../redux/actions/localStorage";

const encodeBase64 = (value) => {
  const bytes = new TextEncoder().encode(value.toString());
  let binary = "";
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary);
};

const decodeBase64 = (value) => {
  const binary = atob(value);
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  return new TextDecoder().decode(bytes);
};

export function setItem(key, value) {
  store.dispatch(setParam(key, value));

  const keyEncode = encodeBase64(key);
  const valueEncode = value ? encodeBase64(value.toString()) : "";

  localStorage.setItem(keyEncode, valueEncode);
}

export function getItem(key) {
  const state = store.getState();

  let value = null;
  if (Object.prototype.hasOwnProperty.call(state, key)) {
    value = state[key];
  } else {
    const keyEncode = encodeBase64(key);
    const stored = localStorage.getItem(keyEncode);
    if (stored) {
      value = decodeBase64(stored);
      setItem(key, value);
    }
  }

  return value;
}

export function removeItem(key) {
  const state = store.getState();

  if (Object.prototype.hasOwnProperty.call(state, key)) {
    delete state[key];
  }

  localStorage.removeItem(encodeBase64(key));
}

export function clearAllItems() {
  store.dispatch(clearParams());
  localStorage.clear();
}
